<template>
    <b-card
        class="list-container shadow-sm"
        bg-variant="white"
        no-body
    >
        <template #header>
            <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                <div>
                    <h6 class="mb-0">연결 프로젝트 목록</h6>
                </div>
            </div>
        </template>
        <!-- DS 표 규칙: '평가 참여 정보' 탭과 같은 모양 — 칸마다 한 줄, 넘치면 줄이고 전체는 title -->
        <b-table
            :items="projects"
            :fields="tableColumns"
            class="mb-0 sticky-header-sort-fix custom-table"
            table-class="ds-table ds-table-fixed connected-project-table"
            :sticky-header="true"
            :empty-html="getEmptyTableHTML"
            show-empty
            responsive
        >
            <!-- 메인 칸 = 진행현황 링크(옛 '확인하기' 버튼 자리). 참여기간은 같은 줄에 흐리게 -->
            <template #cell(project_code)="data">
                <span class="ds-ellipsis" :title="[data.value, data.item.period].filter(Boolean).join(' · ')"><router-link :to="progressRoute(data.item)" class="ds-detail-link">{{ data.value }}</router-link> <span class="ds-sub">{{ data.item.period }}</span></span>
            </template>
            <template #cell(client)="data">
                <span class="ds-ellipsis" :title="data.value">{{ data.value }}</span>
            </template>
            <!-- 응답에 캠페인 이름이 없어 평가산업이 그 자리 — 캠페인 ID 는 흐리게 -->
            <template #cell(industry_name)="data">
                <span class="ds-ellipsis" :title="[data.value, data.item.campaign_id].filter(Boolean).join(' · ')">{{ data.value }} <span class="ds-sub">{{ data.item.campaign_id }}</span></span>
            </template>
            <template #cell(status_code)="data">
                <span class="ds-status" :class="`ds-status-${getProgressTone(data.item)}`">{{ statusLabel(data.item) }}</span>
            </template>
            <template #head(detail)="data">
                <span class="sr-only">{{ data.label }}</span>
            </template>
            <template #cell(detail)="data">
                <router-link :to="progressRoute(data.item)" class="ds-row-icon-btn"
                             :aria-label="`${data.item.project_code} 진행현황`" :title="`${data.item.project_code} 진행현황`">
                    <AppIcon name="chevron-right"/>
                </router-link>
            </template>
        </b-table>
    </b-card>
</template>

<script>
import { getEmptyTableHTML } from '@shared/components/admin/pages/Management/common-data';
import { PROGRESS_STATUS_LABELS } from '@shared/components/admin/pages/Management/Company/data';
import assessmentCommonMixin from '@shared/mixin/assessment.common.mixin';

// DS 표 규칙: 메인(프로젝트 · 참여기간) → 데이터 → 행 아이콘. 폭 없는 칸(프로젝트 · 캠페인)이 남는 폭을 나눠 갖는다
const columns = [
    { key: 'project_code', label: '프로젝트' },
    { key: 'client', label: '원청사', thStyle: { width: '140px' } },
    { key: 'industry_name', label: '캠페인' },
    { key: 'status_code', label: '상태', thStyle: { width: '100px' } },
    { key: 'detail', label: '진행현황', thStyle: { width: '60px' } },
];

export default {
    name: 'ConnectedProject',
    mixins: [assessmentCommonMixin],
    props: {
        selected_company: {
            type: Object,
            required: true,
            default: () => ({ id: null }),
        }
    },
    computed: {
        projects() {
            return this.selected_company.projects || [];
        },
        tableColumns() {
            return columns;
        },
        getEmptyTableHTML() {
            return getEmptyTableHTML('연결된 프로젝트가 없습니다.');
        },
    },
    methods: {
        // 행 전체를 넘겨야 보완요청(in_assessment_ts)·에코바디스(manual_status)도 구분된다
        statusLabel(item) {
            const status = this.getProgressStatus(item);
            return PROGRESS_STATUS_LABELS[status] || status;
        },
        // 옛 '확인하기'(enterProject) 와 같은 곳 — 프로젝트 진행현황
        progressRoute(project) {
            return { name: 'ProjectProgress', query: { client: project.client, pc: project.project_code, cmp: project.campaign_id, admin_mode: 'project' } };
        },
    }
};
</script>

<style lang="scss" scoped>
/* 고정 열 합 300(원청사 140 · 상태 100 · 행 아이콘 60) + 프로젝트 · 캠페인 ~210씩. 기업 상세 탭(1366 메뉴 펼침 표 폭 약 1038) 안 —
   그보다 좁으면 가로 스크롤. 옆 탭(평가 참여 정보 · 소속 유저)과 같은 720 */
::v-deep .connected-project-table {
    min-width: 720px;
}
</style>
